export default __webpack_public_path__ + "static/media/appleAppStoreIcon.196983ce.svg";